module.exports = __webpack_public_path__ + "87bb3083e2e2f163d80175a343cc1b00.png";